import { base64ToBinary } from 'utils/functions/base64-to-binary';

export function checkBase64String(base64String: string) {
  try {
    base64ToBinary(base64String);
  } catch (error) {
    throw new Error('Invalid base64 string');
  }
}
